import React from "react";
import { CheckCircle, XCircle, Send } from "lucide-react";

const ACTION_LABELS = {
  created:                "Oferta creada",
  validation_requested:   "Solicitud enviada a TIC",
  approve:                "Validado por TIC",
  reject:                 "Rechazado por TIC",
  cfo_approve:            "Aprobado por CFO",
  cfo_reject:             "Rechazado por CFO",
  desestimar:             "Desestimada",
  silent_admin_update:    "Actualización silenciosa (admin)",
};

/**
 * Historial de aprobaciones de una oferta TIC.
 * Se muestra en orden cronológico inverso (más reciente arriba).
 *
 * Props:
 *   entries: array de {action, phase?, user, comment, timestamp|ts}
 */
export function ApprovalHistory({ entries }) {
  if (!Array.isArray(entries) || entries.length === 0) return null;

  return (
    <div
      className="mt-5 pt-4 border-t border-gray-100 transition-shadow"
      data-testid="approval-history-section"
    >
      <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
        Historial de aprobaciones
      </p>
      <div className="space-y-3">
        {[...entries].reverse().map((h, i) => {
          const isApprove = h.action === "approve" || h.action === "cfo_approve";
          const isReject  = h.action === "reject"  || h.action === "cfo_reject";
          // Key única: timestamp + acción + phase + índice
          const uniqueKey = `${h.timestamp || h.ts || "no-ts"}-${h.action}-${h.phase || ""}-${i}`;
          const rawTs = h.timestamp || h.ts;
          const tsDate = rawTs ? new Date(rawTs) : null;
          const tsLabel = tsDate && !Number.isNaN(tsDate.getTime())
            ? tsDate.toLocaleDateString("es-ES", {
                day: "2-digit", month: "short", year: "numeric",
                hour: "2-digit", minute: "2-digit"
              })
            : "—";
          return (
            <div key={uniqueKey} className="flex items-start gap-3 text-xs">
              <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5
                ${isApprove ? "bg-green-100" : isReject ? "bg-red-100" : "bg-amber-100"}`}>
                {isApprove ? <CheckCircle size={11} className="text-green-600" />
                  : isReject ? <XCircle size={11} className="text-red-600" />
                  : <Send size={11} className="text-amber-600" />}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-1.5 flex-wrap">
                  <span className="font-semibold text-gray-700">{h.user}</span>
                  <span className="text-gray-300">·</span>
                  <span className="text-gray-500">{ACTION_LABELS[h.action] || h.action}</span>
                  {h.phase && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-indigo-50 text-indigo-700 font-semibold">
                      {h.phase}
                    </span>
                  )}
                  <span className="text-gray-300">·</span>
                  <span className="text-gray-400">{tsLabel}</span>
                </div>
                {h.comment && h.comment !== ACTION_LABELS[h.action] && (
                  <p className="text-gray-500 mt-0.5 italic">{h.comment}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
